import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo_white.png";
import 'bootstrap-icons/font/bootstrap-icons.css';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#153555", color: "white" }}>
      <div className="container py-5">
        <div className="row">

          {/* Column 1 - Logo + About */}
          <div className="col-md-4 mb-4">
            <img src={logo} alt="Logo" height="60" className="mb-3" />
            <p style={{ color: "#cccccc" }}>
              Fredhour is a creative tech studio delivering smart digital
              solutions through design, development, and innovation.
            </p>
            <p style={{ color: "#cccccc" }}>
              Copy Right © 2026 Fred Hour.
            </p>

                <div className="d-flex gap-2 mt-2">
                {/* Instagram */}
                <button
                    className="btn rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    border: "none",
                    }}
                >
                    <i className="bi bi-instagram text-white"></i>
                </button>

                {/* Facebook */}
                <button
                    className="btn rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    border: "none",
                    }}
                >
                    <i className="bi bi-facebook text-white"></i>
                </button>

                {/* Twitter */}
                <button
                    className="btn rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    border: "none",
                    }}
                >
                    <i className="bi bi-twitter text-white"></i>
                </button>

                {/* YouTube */}
                <button
                    className="btn rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    border: "none",
                    }}
                >
                    <i className="bi bi-youtube text-white"></i>
                </button>
                </div>
       
          </div>

          {/* Column 2 - Company */}
          <div className="col-md-2 mb-4">
            <h5 className="fw-bold mb-3">Company</h5>
            <ul className="list-unstyled">
              <li><Link to="/about" className="text-decoration-none text-light">About Us</Link></li>
              <li><Link to="/blog" className="text-decoration-none text-light">Blog</Link></li>
              <li><Link to="/projects" className="text-decoration-none text-light">Projects</Link></li>
              <li><Link to="/career" className="text-decoration-none text-light">Career</Link></li>
              <li><Link to="/contact" className="text-decoration-none text-light">Contact</Link></li>
            </ul>
          </div>

          {/* Column 3 - Newsletter */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Stay up to date</h5>
            <div className="input-group">
              <input
                type="email"
                className="form-control"
                placeholder="Your email address"
              />
              <button
                className="btn"
                style={{ backgroundColor: "#FF8F1C", color: "white" }}
              >
                →
              </button>
            </div>
          </div>

          {/* Column 4 - Contact */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Contact Us</h5>
            <p style={{ color: "#cccccc" }}>
              Khusibu, NayaBazar-17, Kathmandu
            </p>
            <p style={{ color: "#cccccc" }}>
              +977 9860089195 <br />
              01-4335216
            </p>
            <p style={{ color: "#cccccc" }}>
              fredhour.np@gmail.com <br />
              info@fredhour.com.np
            </p>
            
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div
        className="text-center py-3"
        style={{ borderTop: "1px solid rgba(255,255,255,0.2)" }}
      >
        <div className="container d-flex justify-content-between flex-wrap">
          <span>2026 FredHour. All rights reserved.</span>
          <div>
            <Link to="/privacy" className="text-light text-decoration-none me-4">
              Privacy Policy
            </Link>
             <Link to="/account_deletion" className="text-light text-decoration-none me-4">
              Account Deletion
            </Link>
            <Link to="/terms" className="text-light text-decoration-none me-4">
              Terms of Service
            </Link>
            <Link to="/legal" className="text-light text-decoration-none">
              Legal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;